import { render, staticRenderFns } from "./WidgetsView.vue?vue&type=template&id=899930b4&scoped=true&"
import script from "./WidgetsView.vue?vue&type=script&lang=js&"
export * from "./WidgetsView.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsView.vue?vue&type=style&index=0&id=899930b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899930b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
